import { Injectable } from "@angular/core";
import { CheckboxChangeEvent } from "primeng/checkbox";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DisplayPdfFrameQuoteService {
  private Revised$ = new BehaviorSubject<CheckboxChangeEvent | null>(null);
  selectedRevised$ = this.Revised$.asObservable();

  onRevisedSelection(event: CheckboxChangeEvent) {
    this.Revised$.next(event);
  }
}
